import { Modal } from "antd";
import React from "react";
import PaymentMethod from "../../screens/Checkout/paymentMethod";

const PaymentMethodModal = (props: any) => {
  const { t, isVisible, handleClose, handleRetryPayment, orderPrice } = props;

  return (
    <>
      <Modal
        title={t("btn_retry_payment")}
        width={800}
        centered
        visible={isVisible}
        onOk={handleRetryPayment}
        onCancel={handleClose}
        footer={() => <></>}
        zIndex={11}
        className="model-retry-payment">
        <PaymentMethod
          orderPrice={orderPrice}
          paymentMethod={props.paymentMethod.payment_method}
          history={history}
          t={t}
          gotoComplete={(value: any) =>
            handleRetryPayment(value.payment_method)
          }
          isRetryPayment={true}
        />
      </Modal>
    </>
  );
};

export default PaymentMethodModal;
